import { AbstractDataService } from '@nimmsta/ng-commons-lib/data-access';
import { NimmstaDataSource } from '@nimmsta/ng-commons-lib/data-table';
import { SoftwareLabel } from '@nimmsta/ng-commons-lib/models';

export class SoftwareLabelDatasource<T extends SoftwareLabel> extends NimmstaDataSource<T> {
  constructor(dataService: AbstractDataService<T>) {
    super(dataService);
  }
}
